import { useCrudActions } from '@/common/view/useCrudActions';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        levelTimeout: 0,
        groupTimeout: 0,
        findingMatchTimeout: 0,
        canRemove: false
    });

    const validations = {
        levelTimeout: { required, integer, minValue: minValue(1) },
        groupTimeout: { required, integer, minValue: minValue(1) },
        findingMatchTimeout: { required, integer, minValue: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => arenaService.setting.get(),
        onSuccess: ({ data }) => {
            model.levelTimeout = data.levelTimeout;
            model.groupTimeout = data.groupTimeout;
            model.findingMatchTimeout = data.findingMatchTimeout;
            model.canRemove = data.canRemove;
        },
        onError: () => {
            model.levelTimeout = 0;
            model.groupTimeout = 0;
            model.findingMatchTimeout = 0;
            model.canRemove = false;
        }
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () =>
                arenaService.setting.update(model.levelTimeout, model.groupTimeout, model.findingMatchTimeout),
            onSuccess: fetch
        }),
        remove: confirmAndRemove({
            request: arenaService.setting.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
